import { combineReducers } from "redux";

import {
  TasksStateReducer,
  TasksStateArchivedReducer,
  GetTaskMapReducer,
  GetTaskDetailReducer,
  GetTaskMapMemberReducer,
  GetBoardNameReducer,
  BoardToggleDisplay,
  BoardTeamToggleReducer,
  BoardFinancialReducer,
  UploadManagerReducer,
  BoardReminderReducer,
  ProgressChartReducer,
  CurrentDoingReducer,
  TaskMapCurrentDoingReducer,
} from "./ToDo/TaskReducer";

import { CRMReducer } from "./ToDo/CRM/CRMReducer";
import { CrisisReducer } from "./ToDo/Crisis/CrisisReducer";
import { CharterReducer } from "./ToDo/Charter/CharterReducer";
import { ResourcesReducer } from "./ToDo/Resources/ResourcesReducer";
import { MeetingMinutesReducer } from "./ToDo/MeetingMinutes/MeetingMinutesReducer";
import { CorrespondenceReducer } from "./ToDo/Correspondence/CorrespondenceReducer";
import { FormReducer } from "./ToDo/Form/FormReducer";
import { ApprovalReducer } from "./ToDo/Approval/ApprovalReducer";
import { WhiteSpaceReducer } from "./ToDo/WhiteSpace/WhiteSpaceReducer";
import { FlowChartReducer } from "./ToDo/FlowChart/FlowChartReducer";

import {
  BoardChanellDataReducer,
  BoardTaskMapChanellDataReducer,
  NewChatBoardMessageReducer,
  ShareWorkingUsersScreenReducer,
} from "./ToDo/SocketTaskReducer";

import { LoginUserReducer } from "./Login-Register/RLReducer";
import {
  GetUserBoardsReducer,
  UserWalletValueReducer,
  UserInfoReducer,
  UserTasksReducer,
  getUserNotificationsReducer,
  getUserPaymentsReducer,
  getUserAffiliatesReducer,
  RecentTasks,
  UserSettings,
  tetherPriceReducer,
} from "./Dashboard/DashboardReducer";

import { DocumentationReducer } from "./ToDo/Documentation/DocumentationReducer";
import { BoardAiReducer } from "./ToDo/AI/BoardAIReducer";
import { sprintReducer, sprintTasksReducer, archivedSprintsReducer } from "./ToDo/Sprint/sprintReducer";
import { backlogReducer } from "./ToDo/Backlog/backlogReducer";
import { boardCalendarUiReducer } from "./ToDo/BoardCalendarUi/boardCalendarUiReducer";
import { summaryReducer } from "./ToDo/Summary/summaryReducer";
import {
  boardPrivacyReducer,
  resourceUsageReducer,
  memberWorkloadReducer,
} from "./ToDo/Board/boardReducer";
import { boardReportsReducer } from "./ToDo/BoardReports/boardReportsReducer";
import { boardImportExportReducer } from "./ToDo/BoardImportExport/boardImportExportReducer";
import { userProfileReducer } from "./Users/UserProfile/userProfileReducer";
import { userPostsReducer } from "./Users/Posts/postReducer";
import { userStoriesReducer } from "./Users/Stories/storyReducer";
import { expertProfileReducer } from "./Users/Expert/Profile/expertProfileReducer";
import { expertServicesReducer } from "./Users/Expert/Services/expertServicesReducer";
import { expertBookingsReducer } from "./Users/Expert/Bookings/expertBookingsReducer";
import { expertReviewsReducer } from "./Users/Expert/Reviews/expertReviewsReducer";
import { feedReducer } from "./Users/Feed/feedReducer";
import { userChatReducer } from "./Users/Chat/userChatReducer";
import { groupChatReducer } from "./Users/GroupChat/groupChatReducer";
import { discoverReducer } from "./Users/Discover/discoverReducer";
import boardDiscussionUnreadReducer from "./ToDo/BoardDiscussionUnread/unreadReducer";
import { meetingRoomReducer } from "./MeetingRoom/MeetingRoomReducer";
import { aiStudioReducer, coPilotReducer, aiEmployerReducer, aiCatalogReducer, aiSkillReducer } from "./AI";
import { bookReaderReducer } from "./AI/AIStudio/BookReader";
import { docBuilderReducer } from "./AI/AIStudio/DocBuilder";
import { HabitReducer } from "./ToDo/Habit/habitReducer";

const profileSettingsModal = (state = { open: false, section: "general" }, action) => {
  switch (action.type) {
    case "OPEN_PROFILE_SETTINGS":
      return { open: true, section: action.section || "general" };
    case "CLOSE_PROFILE_SETTINGS":
      return { open: false, section: "general" };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  GetUserBoardsReducer: GetUserBoardsReducer,
  LoginUserReducer: LoginUserReducer,
  TasksStateReducer: TasksStateReducer,
  GetTaskMapReducer: GetTaskMapReducer,
  GetTaskDetailReducer: GetTaskDetailReducer,
  GetTaskMapMemberReducer: GetTaskMapMemberReducer,
  UserWalletValueReducer: UserWalletValueReducer,
  GetBoardNameReducer: GetBoardNameReducer,
  BoardToggleDisplay: BoardToggleDisplay,
  BoardTeamToggleReducer: BoardTeamToggleReducer,
  BoardChanellDataReducer: BoardChanellDataReducer,
  BoardTaskMapChanellDataReducer: BoardTaskMapChanellDataReducer,
  NewChatBoardMessageReducer: NewChatBoardMessageReducer,
  UserInfoReducer,
  UserTasksReducer,
  TasksStateArchivedReducer,
  getUserNotificationsReducer,
  getUserPaymentsReducer,
  ShareWorkingUsersScreenReducer,
  BoardFinancialReducer,
  UploadManagerReducer,
  CRMReducer,
  CrisisReducer,
  BoardReminderReducer,
  ProgressChartReducer,
  CurrentDoingReducer,
  TaskMapCurrentDoingReducer,
  getUserAffiliatesReducer,
  CharterReducer,
  RecentTasks,
  UserSettings,
  tetherPriceReducer,
  DocumentationReducer,
  ResourcesReducer,
  MeetingMinutesReducer,
  CorrespondenceReducer,
  FormReducer,
  ApprovalReducer,
  WhiteSpaceReducer,
  FlowChartReducer,
  BoardAiReducer,
  boardSprints: sprintReducer,
  sprintTasks: sprintTasksReducer,
  archivedSprints: archivedSprintsReducer,
  boardCalendarUi: boardCalendarUiReducer,
  boardSummary: summaryReducer,
  boardPrivacy: boardPrivacyReducer,
  resourceUsage: resourceUsageReducer,
  memberWorkload: memberWorkloadReducer,
  boardReports: boardReportsReducer,
  boardImportExport: boardImportExportReducer,
  HabitReducer,
  userProfile: userProfileReducer,
  userPosts: userPostsReducer,
  userStories: userStoriesReducer,
  expertProfile: expertProfileReducer,
  expertServices: expertServicesReducer,
  expertBookings: expertBookingsReducer,
  expertReviews: expertReviewsReducer,
  feed: feedReducer,
  userChat: userChatReducer,
  groupChat: groupChatReducer,
  discover: discoverReducer,
  meetingRoom: meetingRoomReducer,
  aiStudio: aiStudioReducer,
  coPilot: coPilotReducer,
  aiEmployer: aiEmployerReducer,
  aiCatalog: aiCatalogReducer,
  aiSkill: aiSkillReducer,
  bookReader: bookReaderReducer,
  docBuilder: docBuilderReducer,
  boardDiscussionUnread: boardDiscussionUnreadReducer,
  profileSettingsModal: profileSettingsModal,
});

export default rootReducer;
